//./clients/StompClient.ts
import { IStompClient } from '@core/Web/clients/Interfaces/IStompClient';
import { StompAdaptor } from '@Web/adapters/StompAdaptor';
import { IAdaptor } from '@Web/adapters/IAdaptor';
import { STOMP_CONFIG } from '@Web/config/StompConfig';

export class StompClient implements IStompClient {
  private adapterInstance?: IAdaptor;

  init() {
    this.adapterInstance = new StompAdaptor(STOMP_CONFIG);
  }

  adaptor(): IAdaptor {
    if (!this.adapterInstance) {
      throw new Error('StompClient not initialized. Call init() first.');
    }
    return this.adapterInstance;
  }
}
